<template>   
   <HeaderDash />
   
   <ContentUpgrade /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'

import ContentUpgrade from '@/components/worker/dashboard/modules/upgrade/ContentUpgrade.vue'
export default 
{
  name: 'Upgrade',
  components: 
  {
    HeaderDash,
 
    ContentUpgrade
  }
}
</script>

<style>


</style>
